import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/HotjarScript/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/css/satoshi.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/css/style.css");
